/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllResultsResponse,
  HTTPValidationError,
  SimTableResponse,
  StationSimResult,
} from '../models/index';
import {
    AllResultsResponseFromJSON,
    AllResultsResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    SimTableResponseFromJSON,
    SimTableResponseToJSON,
    StationSimResultFromJSON,
    StationSimResultToJSON,
} from '../models/index';

export interface AllResultsApiApiResultBasinIdAllGetRequest {
    basinId: string;
    tgttime: string;
    isEn?: boolean;
}

export interface DamDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
    isEn?: boolean;
}

export interface DamSupportInfoApiApiDamSupportInfoBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
}

export interface FetchTelemeterBasinApiTelemeterBasinTargetGetRequest {
    target: string;
    id: string;
    dateTime: string;
    hours: string;
    interval: string;
    raintype: string;
}

export interface GetTelemeterApiTelemeterTargetGetRequest {
    target: string;
    id: string;
    dateTime: string;
    hours: string;
    interval: string;
}

export interface KokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
}

export interface LastTimeApiApiLastTimeBasinIdStationIdGetRequest {
    basinId: string;
}

export interface ResultApiApiResultBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
    isEn?: boolean;
}

export interface SimTableApiApiSimTableBasinIdStationIdGetRequest {
    basinId: string;
    stationId: string;
    tgttime: string;
}

export interface TableInfoApiApiTableInfoBasinIdGetRequest {
    basinId: string;
    tgttime: string;
}

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     * すべての観測所の予測処理結果
     * All Results Api
     */
    async allResultsApiApiResultBasinIdAllGetRaw(requestParameters: AllResultsApiApiResultBasinIdAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllResultsResponse>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling allResultsApiApiResultBasinIdAllGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling allResultsApiApiResultBasinIdAllGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        if (requestParameters['isEn'] != null) {
            queryParameters['isEn'] = requestParameters['isEn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/result/{basinId}/all`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllResultsResponseFromJSON(jsonValue));
    }

    /**
     * すべての観測所の予測処理結果
     * All Results Api
     */
    async allResultsApiApiResultBasinIdAllGet(requestParameters: AllResultsApiApiResultBasinIdAllGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllResultsResponse> {
        const response = await this.allResultsApiApiResultBasinIdAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ダム支援情報(dischargeinfo)
     * Dam Discharge Info Api
     */
    async damDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGetRaw(requestParameters: DamDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling damDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling damDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling damDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        if (requestParameters['isEn'] != null) {
            queryParameters['isEn'] = requestParameters['isEn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/damDischargeInfo/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ダム支援情報(dischargeinfo)
     * Dam Discharge Info Api
     */
    async damDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGet(requestParameters: DamDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.damDischargeInfoApiApiDamDischargeInfoBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ダム支援情報(supportinfo)  アンサンブル予測もsim_shien.csvは1ファイルのため、96時間先予測と同じ経路で取得する。
     * Dam Support Info Api
     */
    async damSupportInfoApiApiDamSupportInfoBasinIdStationIdGetRaw(requestParameters: DamSupportInfoApiApiDamSupportInfoBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling damSupportInfoApiApiDamSupportInfoBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling damSupportInfoApiApiDamSupportInfoBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling damSupportInfoApiApiDamSupportInfoBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/damSupportInfo/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * ダム支援情報(supportinfo)  アンサンブル予測もsim_shien.csvは1ファイルのため、96時間先予測と同じ経路で取得する。
     * Dam Support Info Api
     */
    async damSupportInfoApiApiDamSupportInfoBasinIdStationIdGet(requestParameters: DamSupportInfoApiApiDamSupportInfoBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.damSupportInfoApiApiDamSupportInfoBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 実績雨量APIから取得したデータを返す  仕様 https://redmine.riskma.jp/issues/362  telemeter/basin/dam: ダム地点 telemeter/basin/gauge: 水位観測所 のwrapper api
     * Fetch Telemeter Basin
     */
    async fetchTelemeterBasinApiTelemeterBasinTargetGetRaw(requestParameters: FetchTelemeterBasinApiTelemeterBasinTargetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['target'] == null) {
            throw new runtime.RequiredError(
                'target',
                'Required parameter "target" was null or undefined when calling fetchTelemeterBasinApiTelemeterBasinTargetGet().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling fetchTelemeterBasinApiTelemeterBasinTargetGet().'
            );
        }

        if (requestParameters['dateTime'] == null) {
            throw new runtime.RequiredError(
                'dateTime',
                'Required parameter "dateTime" was null or undefined when calling fetchTelemeterBasinApiTelemeterBasinTargetGet().'
            );
        }

        if (requestParameters['hours'] == null) {
            throw new runtime.RequiredError(
                'hours',
                'Required parameter "hours" was null or undefined when calling fetchTelemeterBasinApiTelemeterBasinTargetGet().'
            );
        }

        if (requestParameters['interval'] == null) {
            throw new runtime.RequiredError(
                'interval',
                'Required parameter "interval" was null or undefined when calling fetchTelemeterBasinApiTelemeterBasinTargetGet().'
            );
        }

        if (requestParameters['raintype'] == null) {
            throw new runtime.RequiredError(
                'raintype',
                'Required parameter "raintype" was null or undefined when calling fetchTelemeterBasinApiTelemeterBasinTargetGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['dateTime'] != null) {
            queryParameters['date_time'] = requestParameters['dateTime'];
        }

        if (requestParameters['hours'] != null) {
            queryParameters['hours'] = requestParameters['hours'];
        }

        if (requestParameters['interval'] != null) {
            queryParameters['interval'] = requestParameters['interval'];
        }

        if (requestParameters['raintype'] != null) {
            queryParameters['raintype'] = requestParameters['raintype'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/telemeter/basin/{target}`;
        urlPath = urlPath.replace(`{${"target"}}`, encodeURIComponent(String(requestParameters['target'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 実績雨量APIから取得したデータを返す  仕様 https://redmine.riskma.jp/issues/362  telemeter/basin/dam: ダム地点 telemeter/basin/gauge: 水位観測所 のwrapper api
     * Fetch Telemeter Basin
     */
    async fetchTelemeterBasinApiTelemeterBasinTargetGet(requestParameters: FetchTelemeterBasinApiTelemeterBasinTargetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.fetchTelemeterBasinApiTelemeterBasinTargetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Pre Login Info Api
     */
    async getPreLoginInfoApiApiPreLoginInfoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/preLoginInfo`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Pre Login Info Api
     */
    async getPreLoginInfoApiApiPreLoginInfoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getPreLoginInfoApiApiPreLoginInfoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 実績流入量APIから取得したデータを返す  仕様 https://redmine.riskma.jp/issues/362  telemeter/damgauge：ダム地点の諸量（貯水位・流入量・放流量）を返す telemeter/wlevelgauge：水位観測所地点の諸量（水位・流量）を返す
     * Get Telemeter
     */
    async getTelemeterApiTelemeterTargetGetRaw(requestParameters: GetTelemeterApiTelemeterTargetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['target'] == null) {
            throw new runtime.RequiredError(
                'target',
                'Required parameter "target" was null or undefined when calling getTelemeterApiTelemeterTargetGet().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTelemeterApiTelemeterTargetGet().'
            );
        }

        if (requestParameters['dateTime'] == null) {
            throw new runtime.RequiredError(
                'dateTime',
                'Required parameter "dateTime" was null or undefined when calling getTelemeterApiTelemeterTargetGet().'
            );
        }

        if (requestParameters['hours'] == null) {
            throw new runtime.RequiredError(
                'hours',
                'Required parameter "hours" was null or undefined when calling getTelemeterApiTelemeterTargetGet().'
            );
        }

        if (requestParameters['interval'] == null) {
            throw new runtime.RequiredError(
                'interval',
                'Required parameter "interval" was null or undefined when calling getTelemeterApiTelemeterTargetGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['dateTime'] != null) {
            queryParameters['date_time'] = requestParameters['dateTime'];
        }

        if (requestParameters['hours'] != null) {
            queryParameters['hours'] = requestParameters['hours'];
        }

        if (requestParameters['interval'] != null) {
            queryParameters['interval'] = requestParameters['interval'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/telemeter/{target}`;
        urlPath = urlPath.replace(`{${"target"}}`, encodeURIComponent(String(requestParameters['target'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 実績流入量APIから取得したデータを返す  仕様 https://redmine.riskma.jp/issues/362  telemeter/damgauge：ダム地点の諸量（貯水位・流入量・放流量）を返す telemeter/wlevelgauge：水位観測所地点の諸量（水位・流量）を返す
     * Get Telemeter
     */
    async getTelemeterApiTelemeterTargetGet(requestParameters: GetTelemeterApiTelemeterTargetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getTelemeterApiTelemeterTargetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 洪水後期放流支援情報
     * Koki Flood Release Support Info Api
     */
    async kokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGetRaw(requestParameters: KokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling kokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling kokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling kokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/kokiFloodReleaseSupportInfo/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 洪水後期放流支援情報
     * Koki Flood Release Support Info Api
     */
    async kokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGet(requestParameters: KokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.kokiFloodReleaseSupportInfoApiApiKokiFloodReleaseSupportInfoBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Kurihashi Kakuho Api
     */
    async kurihashiKakuhoApiApiKurihashiKakuhoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/kurihashiKakuho`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Kurihashi Kakuho Api
     */
    async kurihashiKakuhoApiApiKurihashiKakuhoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.kurihashiKakuhoApiApiKurihashiKakuhoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 最終予測計算日時
     * Last Time Api
     */
    async lastTimeApiApiLastTimeBasinIdStationIdGetRaw(requestParameters: LastTimeApiApiLastTimeBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling lastTimeApiApiLastTimeBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/lastTime/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 最終予測計算日時
     * Last Time Api
     */
    async lastTimeApiApiLastTimeBasinIdStationIdGet(requestParameters: LastTimeApiApiLastTimeBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.lastTimeApiApiLastTimeBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定観測所の予測処理結果
     * Result Api
     */
    async resultApiApiResultBasinIdStationIdGetRaw(requestParameters: ResultApiApiResultBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationSimResult>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling resultApiApiResultBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling resultApiApiResultBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling resultApiApiResultBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        if (requestParameters['isEn'] != null) {
            queryParameters['isEn'] = requestParameters['isEn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/result/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationSimResultFromJSON(jsonValue));
    }

    /**
     * 指定観測所の予測処理結果
     * Result Api
     */
    async resultApiApiResultBasinIdStationIdGet(requestParameters: ResultApiApiResultBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationSimResult> {
        const response = await this.resultApiApiResultBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * sim_table.csvの中身を整形して取得
     * Sim Table Api
     */
    async simTableApiApiSimTableBasinIdStationIdGetRaw(requestParameters: SimTableApiApiSimTableBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimTableResponse>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling simTableApiApiSimTableBasinIdStationIdGet().'
            );
        }

        if (requestParameters['stationId'] == null) {
            throw new runtime.RequiredError(
                'stationId',
                'Required parameter "stationId" was null or undefined when calling simTableApiApiSimTableBasinIdStationIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling simTableApiApiSimTableBasinIdStationIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/simTable/{basinId}/{stationId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));
        urlPath = urlPath.replace(`{${"stationId"}}`, encodeURIComponent(String(requestParameters['stationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimTableResponseFromJSON(jsonValue));
    }

    /**
     * sim_table.csvの中身を整形して取得
     * Sim Table Api
     */
    async simTableApiApiSimTableBasinIdStationIdGet(requestParameters: SimTableApiApiSimTableBasinIdStationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimTableResponse> {
        const response = await this.simTableApiApiSimTableBasinIdStationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * sysinfo
     * Sys Info Api
     */
    async sysInfoApiApiSysInfoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/sysInfo`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * sysinfo
     * Sys Info Api
     */
    async sysInfoApiApiSysInfoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.sysInfoApiApiSysInfoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * tableinfo
     * Table Info Api
     */
    async tableInfoApiApiTableInfoBasinIdGetRaw(requestParameters: TableInfoApiApiTableInfoBasinIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['basinId'] == null) {
            throw new runtime.RequiredError(
                'basinId',
                'Required parameter "basinId" was null or undefined when calling tableInfoApiApiTableInfoBasinIdGet().'
            );
        }

        if (requestParameters['tgttime'] == null) {
            throw new runtime.RequiredError(
                'tgttime',
                'Required parameter "tgttime" was null or undefined when calling tableInfoApiApiTableInfoBasinIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tgttime'] != null) {
            queryParameters['tgttime'] = requestParameters['tgttime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/tableInfo/{basinId}`;
        urlPath = urlPath.replace(`{${"basinId"}}`, encodeURIComponent(String(requestParameters['basinId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * tableinfo
     * Table Info Api
     */
    async tableInfoApiApiTableInfoBasinIdGet(requestParameters: TableInfoApiApiTableInfoBasinIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.tableInfoApiApiTableInfoBasinIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
